import React from "react"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import { Line } from "react-chartjs-2"

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
)

interface ChartPoint {
  date: string
  web: number
  app: number
  embed: number
}

interface PlayStatsChartProps {
  data: ChartPoint[]
  granularity: "day" | "week" | "month"
}

const formatDate = (dateStr: string, granularity: "day" | "week" | "month") => {
  const d = new Date(dateStr + "T00:00:00")
  if (granularity === "day") {
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" })
  }
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
}

export const PlayStatsChart: React.FC<PlayStatsChartProps> = ({ data, granularity }) => {
  if (!data || data.length === 0) return null

  const chartData = {
    labels: data.map((d) => formatDate(d.date, granularity)),
    datasets: [
      {
        label: "Web",
        data: data.map((d) => d.web),
        borderColor: "#3b82f6",
        backgroundColor: "rgba(59, 130, 246, 0.1)",
        borderWidth: 2,
        pointRadius: 0,
        pointHoverRadius: 4,
        tension: 0.3,
      },
      {
        label: "App",
        data: data.map((d) => d.app),
        borderColor: "#10b981",
        backgroundColor: "rgba(16, 185, 129, 0.1)",
        borderWidth: 2,
        pointRadius: 0,
        pointHoverRadius: 4,
        tension: 0.3,
      },
      {
        label: "Embed",
        data: data.map((d) => d.embed),
        borderColor: "#f59e0b",
        backgroundColor: "rgba(245, 158, 11, 0.1)",
        borderWidth: 2,
        pointRadius: 0,
        pointHoverRadius: 4,
        tension: 0.3,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" as const, align: "start" as const },
      tooltip: { mode: "index" as const, intersect: false },
    },
    scales: {
      y: { beginAtZero: true, ticks: { precision: 0 } },
      x: { ticks: { maxTicksLimit: 10, maxRotation: 0 } },
    },
  }

  return (
    <div className="mt-4 w-full" style={{ height: 240 }}>
      <Line data={chartData} options={options} />
    </div>
  )
}
